import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'dark' | 'light';
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  className = ''
}: SectionHeadingProps) {
  const isLight = tone === 'light';
  return <div className={`mx-auto max-w-3xl text-center ${className}`} data-id="element-225" data-mp="rwzq8b6eq0qd">
      {eyebrow && <p className={`mb-4 font-sans text-xs font-bold uppercase tracking-[0.22em] ${isLight ? 'text-rosa-100' : 'text-frambuesa'}`} data-id="element-226" data-mp="myy57kpf7rc9">
          {eyebrow}
        </p>}
      <h2 className={`font-serif text-3xl leading-tight sm:text-4xl lg:text-[2.75rem] ${isLight ? 'text-white' : 'text-borgona'}`} data-id="element-227" data-mp="d8v4eyc2593d">
        {title}
      </h2>
      <div className={`puntada mx-auto mt-6 h-[3px] w-24 ${isLight ? 'text-rosa-200' : 'text-terracota'}`} aria-hidden="true" data-id="element-228" data-mp="8bd3nv87206g" />
      {subtitle && <p className={`mt-6 font-sans text-lg leading-relaxed sm:text-xl ${isLight ? 'text-rosa-50' : 'text-suave'}`} data-id="element-229" data-mp="3vehu67j26nli">
          {subtitle}
        </p>}
    </div>;
}